import styled from 'styled-components';
import { IconButton } from '@perch-labs/shrike';

export const StyledIconButton = styled(IconButton).attrs({
  icon: 'ChevronRight',
  margin: { right: '24px' },
})<StyleProps>`
  border: none;
  height: 32px;

  &:hover {
    background: ${props => props.theme.colors.background.secondary};
  }

  ${props => props.theme.media.xsmall`
    margin-right: -10px;
  `}
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`;
